module.exports = __webpack_public_path__ + "static/media/arrow-down-chartreuse.74badc17.svg";